import React from 'react'
import { checkDecimal } from 'src/helpers'
import { useMainContext } from './MainContext'

type Props = {
    amount?: string
}

const DemandCharges = ({ amount }: Props) => {

    const { updateShowFromDialog } = useMainContext()

    return (
        <div className="space-y-1 mx-4 ">
            <div className="text-sm font-medium text-gray-700">Demand Charges</div>
            <div className="text-3xl md:text-4xl font-bold text-blue-600">{checkDecimal(Number(amount)?.toString(), true)}</div>
            <button onClick={() => updateShowFromDialog(true)}>
                <div className="flex items-center space-x-1 text-xs text-gray-500 underline underline-offset-2 cursor-pointer hover:text-blue-600 transition-colors">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                    </svg>
                    <span>Change Demand</span>
                </div>
            </button>
        </div>
    )
}

export default DemandCharges